var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_1835)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49996 0.791656C4.69048 0.791656 0.791626 4.69051 0.791626 9.49999C0.791626 14.3094 4.69048 18.2083 9.49996 18.2083C14.3094 18.2083 18.2083 14.3094 18.2083 9.49999C18.2083 4.69051 14.3094 0.791656 9.49996 0.791656ZM12.4347 7.68479C12.7439 7.37562 12.7439 6.87436 12.4347 6.56519C12.1256 6.25603 11.6243 6.25603 11.3152 6.56519L9.49996 8.38041L7.68475 6.56521C7.37559 6.25604 6.87433 6.25604 6.56516 6.56521C6.256 6.87437 6.256 7.37563 6.56516 7.68479L8.38038 9.49999L6.56517 11.3152C6.25601 11.6243 6.25601 12.1256 6.56517 12.4348C6.87433 12.7439 7.37559 12.7439 7.68475 12.4348L9.49996 10.6196L11.3152 12.4348C11.6243 12.7439 12.1256 12.7439 12.4347 12.4348C12.7439 12.1256 12.7439 11.6243 12.4347 11.3152L10.6195 9.49999L12.4347 7.68479Z",
    fill: "#E70A4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_1835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErr);
export default __webpack_public_path__ + "static/media/err.567711c1c27ce10b69da7b7a01da2ae0.svg";
export { ForwardRef as ReactComponent };